import { useState } from 'react';

import { CardArtwork } from '@/components/card';
import type { AssetData } from '@/contents/user-profile/content/artwork/useUserArwork';

import MoreAction from './MoreAction';

const Item: React.FC<{
  collectionId: number;
  asset: AssetData;
  isOwner: boolean;
}> = ({ asset, collectionId, isOwner }) => {
  const [isRemove, setIsRemove] = useState(false);

  if (isRemove) return null;

  return isOwner ? (
    <CardArtwork
      moreAction={
        <MoreAction collectionId={collectionId} asset={asset} setIsRemove={setIsRemove} />
      }
      asset={asset}
    />
  ) : (
    <CardArtwork asset={asset} />
  );
};

export default Item;
